import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  getFolderData,
  signOffStatusChange,
  downloadEsignDoc,
} from "../../api/SignSuccessApi";

function useSignSuccessSelector() {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user") || JSON.stringify(""));
  const [dloadURL, setDloadURL] = useState("");
  const [fileName, setFileName] = useState("");
  const location = useLocation();

  const handleClick = () => navigate(`/dealerZone/${user}`);

  useEffect(() => {
    const folderID = location.search.replace("?folderId=", "").split("&")[0];

    async function getEsignData() {
      const response = await getFolderData(folderID);

      if (!response.data) {
        console.log("no folder data found");
      } else {
        setFileName(response.data.folder.folderName);

        const res = await downloadEsignDoc(folderID);

        var blob = new Blob([res.data], { type: "application/pdf" });

        var url = window.URL || window.webkitURL;

        var downloadUrl = url.createObjectURL(blob);

        setDloadURL(downloadUrl);
      }
    }

    getEsignData();
  }, []);

  useEffect(() => {
    async function postStatus() {
      return await signOffStatusChange();
    }

    if (!location.search) return;
    if (location.search.split("=")[2] === "signing_success") {
      postStatus();
    }
  }, [location.search]);

  return {
    handleClick,
    fileName,
    dloadURL,
    user
  };
}

export default useSignSuccessSelector;
